import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { IoSettingsOutline } from "react-icons/io5";

interface ContentProps {
  activeMenuItem: string;
}

const Content: React.FC<ContentProps> = ({ activeMenuItem }) => {

  return (
    <ContentWrapper>
      {!activeMenuItem ? (
        <EmptyContent>
          <EmptyContentInner>
            <IoSettingsOutline size={400} />
          </EmptyContentInner>
        </EmptyContent>
      ) : (
        <Outlet />
      )}
    </ContentWrapper>
  )
};

export default React.memo(Content);

const ContentWrapper = styled.div`
  padding: 20px 0;
  width: 100%;
  flex: 1;
`;

const EmptyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const EmptyContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(102, 102, 102, 0.5);
`;
